(function () {
  function triggerShopLogin(shell) {
    const shopButton = shell.querySelector('shop-login-button');
    if (!shopButton) return false;

    shopButton.click();

    const shadowButton = shopButton.shadowRoot?.querySelector('button, a');
    if (shadowButton) {
      shadowButton.click();
      return true;
    }

    const nativeButton = shell.querySelector('.header-account-popover__shop-login button, .header-account-popover__shop-login a');
    if (nativeButton) {
      nativeButton.click();
      return true;
    }

    return true;
  }

  function init() {
    const accountMenu = document.querySelector('.header-account-menu');
    if (!accountMenu) return;

    accountMenu.querySelectorAll('.header-account-popover__shop-login-shell').forEach((shell) => {
      const trigger = shell.querySelector('.header-account-popover__shop-trigger');
      if (!trigger || trigger.dataset.shopLoginBound === 'true') return;

      trigger.dataset.shopLoginBound = 'true';
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        triggerShopLogin(shell);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
